import React from 'react';
import './avatar.scss';

const Avatar = ({ children , className }) => {
    return (
        <div className={`avatar ${className}`}>
            {children}
        </div>
    )
}

export default Avatar